import store from '@/store'

import { MetierLocalStorage } from 'modulelocalstorage'
import { $alert } from '@/modules/Utils'
import { Operations } from '@/modules/Operations'
import { Ticket } from '@/modules/Ticket'
import i18n from '@/lang'

/* **************************************
*************** NEPTING *****************
************************************** */

export function silentNeptingLogin () {
  return neptingLogin(null, null, false)
}

export function silentNeptingLogout () {
  return neptingLogout(false)
}

export function neptingLogin (merchant = null, server = null, loader = true) {
  return new Promise((resolve, reject) => {
    if (loader) store.commit('loader', i18n.t('loader.connection'))

    const merchantCode = merchant !== null ? merchant : store.getters.neptingMerchant
    const serverCode = server !== null ? server : store.getters.neptingServer

    const params = {
      merchant_code: merchantCode.toString(),
      web_service_url: serverCode === '' ?
        '' :
        (serverCode === '0' ?
            'https://qualif.nepting.com/nepweb/ws?wsdl' :
            (serverCode === '106' || serverCode === '114' ?
                `https://nepsa1.nepting.com/nepweb/trx?wsdl` :
                `https://nepsa1.nepting.com/nepweb${serverCode}/trx?wsdl`
            )
        )
    }

    if (store.getters.useSoftPos) {
      const p = store.getters.paymentParams
      params.key_alias = p.keyAlias
      params.key_value = p.keyValue
    }

    Pax.login(
      params,
      async (response) => {
        if (loader) {
          store.commit('loader', false)

          setTimeout(() => {
            $alert(i18n.t('success.nepting_connection'), 'success')
          }, 300)
        }

        // Sauvegarde des infos
        await store.dispatch('setPaxMerchant', merchantCode)
        await store.dispatch('setPaxServer', serverCode)
        await store.dispatch('setPaxToken', response.TOKEN)
        await store.dispatch('setPaxOffline', response.OFFLINE_TRS_COUNT)
        MetierLocalStorage.setPaxInfos(store.state.neptingInfos)

        resolve(response)
      },
      (error) => {
        if (loader) {
          store.commit('loader', false)
        }

        setTimeout(() => {
          $alert(Operations.getNeptingError(error))
        }, 300)

        reject(error)
      }
    )
  })
}

export function neptingLogout (loader = true) {
  return new Promise((resolve, reject) => {
    if (loader) store.commit('loader', i18n.t('loader.neptingDisconnection'))

    Pax.logout(
      async (response) => {
        if (loader) store.commit('loader', false)

        await store.dispatch('setPaxToken', null)
        await store.dispatch('setPaxOffline', response.OFFLINE_TRS_COUNT)
        MetierLocalStorage.setPaxInfos(store.state.neptingInfos)

        resolve(response)
      },
      (error) => {
        if (loader) store.commit('loader', false)
        setTimeout(() => {
          $alert(Operations.getNeptingError(error))
        }, 300)

        reject(error)
      }
    )
  })
}

export function neptingRequest (type) {
  return new Promise((resolve, reject) => {
    Pax.request(
      {
        message_type: type,
        token: store.state.neptingInfos.token
      },
      (response) => {
        let tickets = []
        if (response.HOLDER_TICKET) {
          tickets.push(Ticket.formatBankingTicket(response.HOLDER_TICKET))
        }
        if (response.MERCHANT_TICKET) {
          tickets.push(Ticket.formatBankingTicket(response.MERCHANT_TICKET, true))
        }

        resolve(tickets)
      },
      (error) => {
        $alert(Operations.getNeptingError(error))
        reject(error)
      }
    )
  })
}

export function neptingReport (type) {
  return new Promise((resolve, reject) => {
    Pax.report(
      {
        sub_message_type: type,
        token: store.state.neptingInfos.token
      },
      (response) => {
        let tickets = []
        if (response.MERCHANT_TICKET) {
          tickets.push(Ticket.formatBankingTicket(response.MERCHANT_TICKET))
        }

        resolve(tickets)
      },
      (error) => {
        $alert(Operations.getNeptingError(error))
        reject(error)
      }
    )
  })
}

/* **************************************
*************** PAX FRV6 ****************
************************************** */


